import React from 'react';
import { Divider } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { styles } from './divider-styles';

const tDivider = ({ classes }) => <Divider light className={classes.divider} />;

// export default withStyles(styles, { withTheme: true })(Divider);
export default withStyles(styles, { withTheme: true })(tDivider);
